<template>
  <div>
    <div class="header-wrapper">
      <div class="header">新建文章</div>
      <div class="btn-wrapper">
        <header-btn @saveSend="saveSend" :articleIdList="IdList" :saveLoading="saveLoading" ref="headbtn"></header-btn>
      </div>
    </div>
    <div class="box left-container">
      <newnotice-left
        style="margin-left:20px"
        @changeInfo="changeInfo"
        :sendItems="sendItems"
        @addSend="addSend"
        @moveForward="moveForward"
        @moveBack="moveBack"
        @delArticle="delArticle"
      ></newnotice-left>
      <div class="right-wrapper box_v">
        <div class="edit-wrapper">
          <editor-box
            :show-footer="false"
            :content-hight="410"
            @editorContent="editorContent"
            :content="lastContent"
          >
            <div class="editslot">
              <div class="notive-title">标题</div>
              <div class="input-wrapper box">
                <input
                  placeholder="请在这里输入标题"
                  :value="editTitle"
                  class="edit-title box_f1"
                  @input="titleinput"
                  maxlength="64"
                >
                <div class="title-number">{{titleNum}}/64</div>
              </div>
            </div>
          </editor-box>
        </div>
        <div class="select-cover">
          <div class="notive-title">封面图</div>
          <upload-img
            :imgArr="coverArr"
            :imgNumber="coverNumber"
            :fixedNumber="fixedNum"
            :imgHeight="70"
            @saveImg="saveImg"
            @delPic="delPic"
          >
            <div class="cover">上传封面</div>
          </upload-img>
        </div>
        <div class="abstract">
          <div class="notive-title">摘要</div>
          <textarea
            type="text"
            placeholder="请输入..."
            :value="abstract"
            class="abstract-input"
            @input="abstractinput"
            maxlength="120"
          />
          <span class="abstract-number">{{abstractNum}}/120</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import newnoticeLeft from "./components/newnoticeLeft";
import editorBox from "../../components/editorBox";
import uploadImg from "../../components/uploadImg";
import headerBtn from "./components/newNoticeBtn";
export default {
  components: {
    newnoticeLeft,
    editorBox,
    uploadImg,
    headerBtn
  },
  data() {
    return {
      editTitle: "", //editor标题
      // titleNum: 0, //标题输入的字数
      abstract: "", //摘要内容
      // abstractNum: 0, //摘要内容字数
      coverArr: [], //封面图片
      coverNumber: 1, //要传封面的个数，固定为1，组件用

      sendItems: [],
      changeIndex: 0, //在编辑的列表索引
      changeItem: "", //被选择的一条推送
      editorInfo: "", //正文内容
      lastContent:'', // 上次的内容
      isNodata: false, //是否有推送列表 ， 用于第一次传图片时的尺寸
      saveLoading: false
    };
  },
  computed: {
    IdList() {
      var idList = [];
      this.sendItems.forEach(item => {
        idList.push(item.id);
      });
      return idList;
    },
    fixedNum() {
      //封面尺寸比例  组件用
      if (this.changeIndex == 0) {
        return [2.35, 1];
      } else {
        return [1, 1];
      }
    },
    titleNum () {
      return this.editTitle.length;
    },//标题输入的字数
    abstractNum () {
      return this.abstract.length
    }//摘要内容字数
  },
  methods: {
    delArticle(index) {
      //删除未发送推送
      var id = this.sendItems[index].id;
      if (id) {
        var url = this.urlobj.delSend(id);
        this.$delete(url).then(res => {
          if (res.isSucceed) {
            this.$Message.success("删除成功");
            this.getSendList();
            if (this.changeIndex > index) {
              this.changeIndex--;
              this.changeInfo(this.changeIndex);
            } else if (this.changeIndex > index) {
              this.changeIndex = 0;
              this.changeInfo(0);
            }
          }
        });
      } else {
        this.sendItems.splice(index, 1);
      }
    },
    moveBack(index) {
      //下移
      var that = this;
      if (index < this.sendItems.length - 1) {
        var temp = this.sendItems[index];
        this.$set(this.sendItems, index, this.sendItems[index + 1]);
        this.$set(this.sendItems, index + 1, temp);
        if ((index = this.changeIndex)) {
          this.changeIndex++;
        }
        var url = that.urlobj.Sortsend() + "?articleIdList=" + this.IdList;
        that.$post(url).then(res => {
          // console.log(res); //排序接口
        });
      }
    },
    moveForward(index) {
      //上移
      var that = this;
      if (index != 0) {
        var temp = this.sendItems[index - 1];
        this.$set(this.sendItems, index - 1, this.sendItems[index]);
        this.$set(this.sendItems, index, temp);
        if ((index = this.changeIndex)) {
          this.changeIndex--;
        }
        var articleIdList = [];
        this.sendItems.forEach(item => {
          articleIdList.push(item.id);
        });
        var url = that.urlobj.Sortsend() + "?articleIdList=" + articleIdList;
        that.$post(url).then(res => {
        });
      }
    },
    delPic(data) {
      var url = this.urlobj.delSendImg(data.id);
      this.$delete(url).then(res => {
        if (res.isSucceed) {
          this.$Message.success("删除成功");
          this.coverArr = [];
          this.sendItems[this.changeIndex].coverPicUrl = "";
          this.sendItems[this.changeIndex].coverPicId = '';
        }
      });
    },
    saveImg(data) {
      //保存图片的同时，与左侧列表保持变化一致
      this.coverArr.push(data);
      this.sendItems[this.changeIndex].coverPicUrl = this.coverArr[0].path;
      this.sendItems[this.changeIndex].coverPicId = this.coverArr[0].id;
    },
    editorContent (data) {
      this.editorInfo = data;
      this.sendItems[this.changeIndex].context = data;
    },
    //标题输入框事件
    titleinput(e) {
      //标题输入框事件
      // this.titleNum = e.target.value.length;
      this.editTitle = e.target.value;
      this.sendItems[this.changeIndex].title = e.target.value;
    },
    //摘要输入事件
    abstractinput(e) {
      //摘要输入事件
      // this.abstractNum = e.target.value.length;
      this.abstract = e.target.value;
      this.sendItems[this.changeIndex].summary = e.target.value;
    },
    changeInfo(index) {
      //点击左侧列表触发事件，将点击的推送信息同步到右侧编辑区域
      this.changeIndex = index;
      var id = this.sendItems[index].id;
      if (id) {
        var url = this.urlobj.getSendInfo(id);
        this.$get(url).then(res => {
          if (res.isSucceed) {
            this.changeItem = res.rows[0];
            this.tongbu();
          }
        });
      } else {
        this.changeItem = this.sendItems[index];
        this.tongbu();
      }
    },
    tongbu() {
      var item = this.changeItem;
      this.editTitle = item.title; //同步标题
      var img = {};
      img.path = item.coverPicUrl;
      img.id = item.coverPicId;
      if (item.coverPicUrl) {
        if (this.coverArr) {
          this.coverArr.splice(0, 1, img);
        } else {
          this.coverArr.push(img);
        }
      } else {
        this.coverArr = [];
      } //同步封面
      this.abstract = item.summary; //同步摘要
      this.editorInfo = item.context; //同步内容
      this.lastContent = item.context; //同步内容
    },
    addSend() {
      //左侧添加新的推送项
      if (this.sendItems.length == 8) {
        this.$Message.warning("最多添加8条");
        return;
      }
      this.sendItems.push({
        title: "",
        coverPicId: 0,
        coverPicUrl: "",
        summary:'',
        context:''
      });
    },
    getSendList() {
      //获取待推送列表
      var url = this.urlobj.getsendList() + "?sendType=unsend";
      this.$post(url, {
        pageNum: 1,
        pageSize: 15
      }).then(res => {
        this.sendItems = res.rows;
        if (res.rows.length == 0) {
          this.isNodata = true;
        }
        !this.isNodata&&this.changeInfo(this.changeIndex);
      });
    },
    saveSend(params) {
      //保存新编辑项
      let data = this.sendItems.map((item, index) => {
        let reg = /<\/?.+?\/?>/g;
        let content = item.context?item.context.replace(reg, ""):"";
        return {
          id:item.id || -1, // 新增的公告 传-1
          title:item.title, // 标题
          coverPicId:item.coverPicId, // 封面图片
          summary:item.summary || content.slice(0,54), // 摘要
          sort:index, // 排序
          context:item.context // 内容
        }
      });
      var url = this.urlobj.saveSend();
      this.saveLoading = true;
      this.$post(url, data)
        .then(res => {
          this.saveLoading = false;
          if (params.type == 'yulan'){
            this.$refs.headbtn.yulan()
          }else if (params.type == 'qunfa') {
            this.articleIdList=res.newPrimaryKeys.idList
            this.$refs.headbtn.qunfa()
          }else {

            this.$Message.success("保存成功");
            this.getSendList()
          }
        })
        .catch(e => {
          this.saveLoading = false;
        })
    },
  },
  mounted() {
    this.getSendList();
  }
};
</script>

<style scoped>
  .edit-wrapper >>> .ql-editor.ql-blank::before{
    font-style: normal ;
  }
.header-wrapper {
  display: flex;
  /*height: 30px;*/
  height: 85px;
  line-height: 85px;
  justify-content: center;
  text-align: center;
  position: relative;
  color: #656565;
}
.header {
  font-size: 25px;
  text-align: center;
}
.left-container {
  align-items: flex-start;
}
.btn-wrapper {
  position: absolute;
  right: 20px;
  z-index:100
}
.right-wrapper {
  margin: 0 20px;
  flex: 1;
  justify-content: space-between;
}
.editslot {
  width: 100%;
  padding: 40px 15px 20px;
  height: 120px;
}
.input-wrapper {
  position: absolute;
  bottom: 10px;
  width: 97%;
}
.edit-title {
  width: 100%;
  border: none;
  resize: none;
  outline: none;
  font-size: 16px;
  color: #666;
}
.title-number {
  text-align: right;
  font-size: 14px;
  height: 14px;
  line-height: 14px;
  color: #999;
}
.edit-wrapper {
  background: #fff;
  height: 572px;
}
.select-cover {
  height: 150px;
  border: 1px solid #ccc;
  background: #fff;
  padding: 20px;
}
.notive-title {
  font-size: 18px;
  color: #333;
  font-weight: 600;
  margin-bottom: 10px;
}
.cover {
  color: #999;
  border: 1px solid #ccc;
  width: 100px;
  height: 70px;
  font-size: 13px;
  text-align: center;
  line-height: 70px;
}
.abstract {
  height: 140px;
  border: 1px solid #ccc;
  background: #fff;
  padding: 20px;
  position: relative;
}
.abstract-number {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.abstract-input {
  width: 95%;
  height: 65px;
  overflow: auto;
  resize: none;
  border: 0;
  font-size: 16px;
}

</style>
